import React from 'react';
import HeroSection from './HeroSection/Motability7HeroSection';
import SelectCarSection from './SelectCarSection/Motability7SelectCarSection';
import ContactSection from './ContactSection/Motability7ContactSection';

const MotabilityPricelistJaecoo7 = ({ fields }) => {
  // 映射数据到各个部分
  const hero = {
    text: fields.heroText,
    image: fields.heroImage,
  };

  const selectCar = fields.carItem || [];

  const contact = {
    buttonLink: fields.contactbuttonText,
    buttonUrl: fields.contactButtonUrl,
    isComingSoon: fields.isComingSoon,
    isComingSoonText: fields.isComingSoonText,
    text: fields.contactText,
    image: fields.contactImage,
    mobileImage: fields.contactImage,
  };

  return (
    <div className="container">
      <HeroSection heroSectionData={hero} />
      <SelectCarSection data={selectCar} />
      <ContactSection contactSectionData={contact} />
    </div>
  );
};

export default MotabilityPricelistJaecoo7;
